import { ZapRunsPage } from "@zapier/reporting";

import { PageLayout, Title } from "../../../components";

export default function History() {
  return (
    <Title title="Zap Runs | Zap History">
      <PageLayout>
        <ZapRunsPage />
      </PageLayout>
    </Title>
  );
}
